if (!customElements.get("fav-video")) {
	class FavVideo extends HTMLElement {
		constructor() {
			super();
			this.isMuted = true;
			this.slider = this.querySelector('.swiper');
			this.titleElement = this.querySelector(".video_title");
			this.videos = this.querySelectorAll("video");
			this.pauseButton = this.querySelector(".play-toggle");
			this.muteButton = this.querySelector(".mute_container");
			this.muteButton?.addEventListener("click", this.muteToggleHandler.bind(this));
			this.pauseButton?.addEventListener("click", this.pauseToggleHandler.bind(this));
		}

		handleSlideChange(skipTransition = false) {
			!skipTransition && this.initTransition();
			this.clearEventListener();
			this.pauseAllVideos();
			this.initCurrentVideo();
		}

		initTransition() {
			this.classList.add("is-transitioning");
			setTimeout(() => {
				this.classList.remove("is-transitioning");
			}, 200);
		}

		pauseAllVideos() {
			this.videos.forEach((video) => {
				video.pause();
			});
		}

		pauseToggleHandler() {
			if (!this.currentVideo) return;

			if (this.currentVideo.paused) {
				this.currentVideo.play();
			} else {
				this.currentVideo.pause();
			}
		}

		muteToggleHandler() {
			this.isMuted = !this.isMuted;
			if (!this.currentVideo) return;

			this.currentVideo.muted = this.isMuted;
		}

		initCurrentVideo() {
			this.currentVideo = this.querySelector(".swiper-slide-active video");
			if (!this.currentVideo) return;

			this.pauseButton.classList.remove("is-paused");
			this.titleElement.innerHTML = this.currentVideo.parentNode.dataset.title;
			this.currentVideo.muted = this.isMuted;
			this.currentVideo.currentTime = 0;
			this.currentVideo.onended = this.goToNextSlide.bind(this);
			this.currentVideo.play();
			this.setProgress();
		}

		clearEventListener() {
			if (!this.currentVideo) return;
			this.currentVideo.onended = null;
		}

		goToNextSlide() {
			this.slider.swiper.slideNext(0);
		}

		setProgress() {
			const duration = this.currentVideo.duration;
			clearInterval(this.progressInterval);
			this.progressInterval = setInterval(() => {
				if (!this.currentVideo.paused && this.currentVideo.currentTime > 0) {
					var progress = (this.currentVideo.currentTime / duration) * 100;
					this.pauseButton.style.setProperty("--progress", progress + "%");
				}
			}, 50);
		}
	}
	customElements.define("fav-video", FavVideo);
}